import LottieFans from '../lotties/tools.json';
import LottieSponsors from '../lotties/ar_experience.json';
import LottieRevenue from '../lotties/sports_goods.json';
import LottieCorporate from '../lotties/digital_experience.json';

const Benefits = [
    {
        topic: 'Fan Engagement',
        title: 'Fan Engagement',
        // text: 'While they get involved with the AR Experiences we are reading all their moves, where are they looking at, geo localization, time spent, daily usage, etc... so you can monetize your fans more efficiently.',
        text: 'Our AR Experiences will help strenghten the bond between the club and the fan. Get to know more about your fans’ preferences with our Dashboard tailored to cater your needs.',
        lottieAnimation: LottieFans,
    },
    {
        topic: 'For the Sponsors',
        title: 'For the Sponsors',
        // text: 'Let the Sponsors get involved in the AR Experiences. We can create new forms of revenue that can allow sponsors to attract new potential buyers. AR games, AR discounts and new shopping experiences are some examples of how sponsors can generate new revenues.',
        text: 'Get your Sponsors involved in our AR Experiences. We can create new forms of revenue that can be utilized to reach new audiences. Shopping experiences, games and promotions are some examples of how sponsors can generate new revenues through our AR Technology.',
        lottieAnimation: LottieSponsors,
    },
    {
        topic: 'Revenue Streams',
        title: 'Revenue Streams',
        // text: 'Splink® Collectibles are official sports goods that are linked through a licensing agreement or a revenue share agreement.',
        text: 'Generate revenue through our licensed Collectibles which are accessible to all fans around the world through our e-commerce and our global retail network.',
        lottieAnimation: LottieRevenue,
    },
    {
        topic: 'Corporate',
        title: 'Corporate',
        // text: 'Create digital experiences with our assets. AR Players can showcase a new product, launch a new club activation, create experiences for your business partners and much more.',
        text: 'Create unique digital experiences with our assets. Our AR Players can showcase a new product, launch a new club activation for your business partners and much more.',
        lottieAnimation: LottieCorporate,
    },
];

export default Benefits;
